import { Inline, Stack, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { ReactNode } from 'react';
import type { TripInfoType } from './constants';
import { EVENT_SEGMENT_TYPE_TO_TITLE_KEY, PARTNER_EVENT_TYPES } from './constants';
import TripEventIcon from './TripEventIcon';

const wrapperStackStyles = (hasDescription: boolean, backgroundColor: string) => css`
  background-color: ${backgroundColor};
  border-radius: 4px;
  padding: ${hasDescription ? '16px' : '4px 8px'};
`;

const headerInlineStyles = (foregroundColor: string) => css`
  color: ${foregroundColor};
  fill: ${foregroundColor};
  font-weight: 700;
`;

interface TripEventBadgeProps {
  type: TripInfoType;
  content?: ReactNode;
  hasTitle?: boolean;
}
const TripEventBadge = ({ type, hasTitle, content }: TripEventBadgeProps) => {
  const { t } = useTranslation();
  const isPartnerEventType = PARTNER_EVENT_TYPES.includes(type);
  const badgeColor = {
    background: isPartnerEventType ? '#c2e2ff' : vars.colors.signal.caution.tint,
    foreground: isPartnerEventType ? '#0057a7' : vars.colors.signal.caution.dark,
  };

  return (
    <Stack
      as="li"
      className={wrapperStackStyles(Boolean(content), badgeColor.background)}
      spacing={8}
    >
      <Inline
        alignY="center"
        className={headerInlineStyles(badgeColor.foreground)}
        noWrap
        spacing={4}
      >
        <TripEventIcon type={type} />
        {hasTitle && (
          <span data-testid={`trip-event-${type}-title`}>
            {t(EVENT_SEGMENT_TYPE_TO_TITLE_KEY[type])}
          </span>
        )}
      </Inline>
      {content}
    </Stack>
  );
};

export default TripEventBadge;
